import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import PolicyNav, { POLICY_UPDATED } from "./PolicyNav";
import "../css/privacy.scss";

export default function Cancellations() {
  return (
    <main className="policy-page privacy">
      <header className="policy-hero policy-hero--legal">
        <p className="policy-eyebrow">Customer care</p>
        <h1>Order changes &amp; cancellations</h1>
        <p>What we can change before an order enters fulfilment.</p>
        <span>Effective {POLICY_UPDATED}</span>
      </header>
      <div className="policy-layout">
        <PolicyNav current="/cancellations" />
        <article className="policy-content policy-content--legal">
          <section className="policy-intro" aria-labelledby="cancel-overview">
            <p className="policy-eyebrow">Act quickly</p>
            <h2 id="cancel-overview">We will try before the parcel moves.</h2>
            <p>
              Email us as soon as you notice a mistake. Changes and cancellations
              are not guaranteed because orders may enter processing immediately.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="cancel-request">
            <div className="policy-section__heading"><span>01</span><h2 id="cancel-request">How to request a change</h2></div>
            <p>
              Email {siteConfig.contact.email} with the order number, checkout
              email, and exact requested change. Do not send payment credentials.
              A request is accepted only when we confirm it in writing.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="cancel-possible">
            <div className="policy-section__heading"><span>02</span><h2 id="cancel-possible">What may be changed</h2></div>
            <p>
              Before processing, we may be able to correct a name or address,
              remove an item, or cancel the order. We generally cannot add items,
              change payment methods, combine orders, or change a product variant
              after payment; a new order may be required.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="cancel-limits">
            <div className="policy-section__heading"><span>03</span><h2 id="cancel-limits">When cancellation is unavailable</h2></div>
            <p>
              An order cannot normally be cancelled after dispatch. Personalized,
              altered, made-to-order, or final-sale items may become non-cancellable
              once work begins if that limitation was disclosed before purchase.
              If cancellation is no longer possible, the <Link to="/returns">Returns &amp; Refunds Policy</Link> applies after delivery.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="cancel-refund">
            <div className="policy-section__heading"><span>04</span><h2 id="cancel-refund">Payment holds &amp; refunds</h2></div>
            <p>
              A cancelled authorization may remain pending until your bank releases
              it. If payment was captured, we will issue an approved cancellation
              refund to the original payment method. Your provider controls when
              the credit appears.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="cancel-merchant">
            <div className="policy-section__heading"><span>05</span><h2 id="cancel-merchant">Cancellations by us</h2></div>
            <p>
              We may cancel all or part of an order for unavailability, an obvious
              pricing error, failed verification, delivery restrictions, purchase-
              limit abuse, suspected fraud, sanctions concerns, or another lawful
              reason. We will notify you and refund any captured amount for the
              cancelled portion.
            </p>
          </section>

          <section className="policy-help"><div><p className="policy-eyebrow">Order help</p><h2>Include your order number.</h2></div><a href={`mailto:${siteConfig.contact.email}`}>Request a change <span aria-hidden="true">↗</span></a></section>
        </article>
      </div>
    </main>
  );
}
